import { input, Component, signal, viewChildren } from '@angular/core';

import { VideoPlayerComponent } from '../video-player/video-player';

export interface CardData {
  video: string;
  title: string;
  poster?: string;
  description: string;
  duration?: number;
}

@Component({
  selector: 'app-hover-expandable-cards',
  imports: [VideoPlayerComponent],
  templateUrl: './hover-expandable-cards.html',
})
export class HoverExpandableCardsComponent {
  videoPlayers = viewChildren(VideoPlayerComponent);

  cards = input.required<CardData[]>();

  activeIndex = signal(0);

  onCardHover(cardIndex: number): void {
    this.activeIndex.set(cardIndex);
    this.activateVideos();
  }

  private activateVideos(): void {
    this.videoPlayers().forEach((videoPlayer, playerIndex) => {
      if (playerIndex === this.activeIndex()) {
        videoPlayer.play();
      } else {
        videoPlayer.pause();
      }
    });
  }
}
